import {useEffect, useState} from 'react';
import {getArticles} from '../lib/getArticles';
import {Article} from '../types/article';
import {Button, Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle} from "@diaboro87/ui";
import {Link} from "react-router-dom";
import '../style/tmp.css';

export default function Home() {
    const [articles, setArticles] = useState<Article[]>([]);
    const PREVIEW_LENGTH = 80;
    useEffect(() => {
        (async () => {
            const data = await getArticles();
            setArticles(data);
        })();
    }, []);

    return (
        <main className="flex-1">
            <div className="mx-auto max-w-6xl px-6">
                <section className="container mx-auto px-4 py-16 text-center">
                    <h1 className="tmp-title text-4xl font-bold text-foreground mb-4 text-balance">Welcome to
                        satoryohub</h1>
                    <p className="tmp-header text-lg text-muted-foreground mx-auto break-words">
                        RYO@暇人のクリエイティブな活動をまとめたブログへようこそ。
                    </p>
                </section>

                <div className="grid gap-6 md:grid-cols-3">
                    {articles.map((article: Article) => (

                        <Card key={article.id} className="h-full flex flex-col">
                            <CardHeader>
                                <CardTitle>{article.title}</CardTitle>
                                <CardDescription>投稿日: {article?.createdAt ? new Date(article.createdAt).toLocaleDateString('ja-JP') : "不明"}</CardDescription>
                            </CardHeader>
                            <CardContent>
                                <p>{article.content ? article.content.substring(0, PREVIEW_LENGTH) + '...' : '内容がありません'}</p>
                            </CardContent>
                            <CardFooter>
                                <Button className="tmp-button--invert" asChild>
                                    <Link to={`/posts/${article.id}`}>記事を読む</Link>
                                </Button>
                            </CardFooter>
                        </Card>
                    ))}
                </div>
            </div>
        </main>
    );
}
